module.exports = __webpack_public_path__ + "static/img/icon-access-history.743b3ee.png";